function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2,13H5a1,1,0,0,0,0-2H4.635l.586-1.692H8.779L9.365,11H9a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2h-.519L8.945,3.673A1,1,0,0,0,8,3H6a1,1,0,0,0-.945.673L2.519,11H2a1,1,0,0,0,0,2ZM6.711,5h.577l.8,2.308H5.913Zm4.567,10.483,3.085,3.085,6.913-7.257a1,1,0,1,1,1.448,1.378l-7.619,8a1,1,0,0,1-.712.311h-.012a1,1,0,0,1-.707-.293L9.864,16.9a1,1,0,1,1,1.414-1.414Z"
});

function SvgSpellcheck(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 24 24",
    width: 20.033082163363,
    height: 20.033082163363,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpellcheck);
export default __webpack_public_path__ + "static/media/spellcheck.23de7454.svg";
export { ForwardRef as ReactComponent };